import React from 'react'

const HelpDesk = () => {
  return (
    <>
      <iframe
        id="iframe"
        className="w-full min-h-2screen"
        scrolling="no"
        src="https://v1.embednotion.com/embed/6ba22d8b01b146b4b072077d5ce8e657"
      ></iframe>
    </>
  )
}

export default HelpDesk
